export interface Props {
  title: string;
}

export function TooltipContent() {
  return (
    <div style={{ maxWidth: 430 }}>
      In a net impact profile, you can see impact scores estimated by Upright's AI Leena-Leena for each impact category
      and dimension, as well as a net score summing it all up. Net impact is just negative impacts subtracted from
      positive impacts.
    </div>
  );
}
